import { Mail } from "lucide-react";
import { MAILTO } from "@/lib/site";

export default function Contact() {
  return (
    <section id="contact" className="section section-white" data-testid="contact-section">
      <div className="wrap contact-grid">
        <div>
          <div className="eyebrow">Contact</div>
          <h2>Request specifications, samples or a commercial quote.</h2>
        </div>
        <div className="email-card" data-testid="email-card">
          <div className="email-icon" aria-hidden="true"><Mail size={26} /></div>
          <h3>Start a conversation</h3>
          <p>
            Share your product requirement, application area or documentation need. We&apos;ll respond with the most
            relevant specifications, samples or next steps.
          </p>
          <a className="btn btn-primary" href={MAILTO} data-testid="email-cta">
            Email Himalayan Actives
          </a>
        </div>
      </div>
    </section>
  );
}
